import {
  NBS_API_APPLE_REQUEST,
  NBS_API_APPLE_SUCCESS,
  NBS_API_APPLE_FAILURE,
} from '../../constants/actions';

import nbsApi from '../../assets/helpers/nbsApi';
import { deviceId, trackNewProfile } from '../../assets/helpers/utils';
import strings from '../../assets/localization';
import { gtmTrack } from '../../assets/helpers/GAHelper';

function nbsApiAppleAuthRequest() {
  return { type: NBS_API_APPLE_REQUEST };
}
function nbsApiAppleAuthSuccess(response) {
  return {
    type: NBS_API_APPLE_SUCCESS,
    response,
  };
}
function nbsApiAppleAuthError(error) {
  return {
    type: NBS_API_APPLE_FAILURE,
    error: error.cause || error,
  };
}

export function nbsApiAppleAuth(data) {
  data.device_id = deviceId();
  return (dispatch) => {
    dispatch(nbsApiAppleAuthRequest());
    return nbsApi('login', data)
      .then((response) => {
        if (data.lp_profile_created === true) {
          trackNewProfile();
        }
        gtmTrack({
          event: 'login',
          method: 'apple',
          // 'user_id': 'INSERT_HASHED_USER_ID'
        });
        dispatch(nbsApiAppleAuthSuccess(response));
      })
      .catch((error) => {
        const newError = error.cause || error;
        // 2 - Account Not Found, Please Sign Up
        // do not display error - just do sign-up
        if (newError.error_code === 2) {
          let lang = '';
          if (!data.language) {
            lang = strings.getLanguage();
          }
          let signUpData = { ...data, signup_type: 'apple', language: lang };
          return nbsApi('signup', signUpData)
            .then((resData) => {
              trackNewProfile();
              gtmTrack({
                event: 'sign_up',
                signup_type: 'home',
                method: 'apple',
                user_id: resData.user_id,
              });
              // in case signup is success just login user
              return nbsApi('login', data)
                .then((response) => dispatch(nbsApiAppleAuthSuccess(response)))
                .catch((error) => dispatch(nbsApiAppleAuthError(error)));
            })
            .catch((error) => dispatch(nbsApiAppleAuthError(error)));
        } else {
          dispatch(nbsApiAppleAuthError(error));
        }
      });
  };
}
